var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"icon-badge",attrs:{"variant":_vm.getStatusHelper(),"pill":""}},[_c('a',{attrs:{"href":`${_vm.nereus_url}`,"target":"_blank"}},[_c('status-icon',{attrs:{"refDes":_vm.instRD,"iconValue":_vm.iconValue}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }